import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { useConfigUI } from '@/features/config/context'
import { FormFlowValve } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers'

async function createFlowValve(payload: FormFlowValve) {
  await flowValveApi.create(payload)
}

function useAddFlowValve() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: FormFlowValve) => createFlowValve(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.flowValve])
      toast.success(t('addFlowRuleSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useAddFlowValve
